
      const preloaderId = 'cedrum-preloader';
      const preloaderLottieId = 'cedrum-preloader-lottie';
      const container = document.getElementById(preloaderLottieId);
      const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
      let animation = null;
      let isHidden = false;

      function hidePreloader() {
        if (isHidden) return;
        isHidden = true;
        const el = document.getElementById(preloaderId);
        if (!el) return;
        el.classList.add('cedrum-preloader--hide');
        window.setTimeout(() => {
          try {
            animation?.destroy();
          } catch (error) {
            void error;
          }
          el.remove();
        }, 220);
      }

      window.__CEDRUM_PRELOADER__ = window.__CEDRUM_PRELOADER__ || {};
      window.__CEDRUM_PRELOADER__.hide = hidePreloader;

      if (container) {
        import('lottie-web')
          .then((module) => {
            const lottie = module?.default ?? module;
            animation = lottie.loadAnimation({
              container,
              renderer: 'svg',
              loop: !prefersReduced,
              autoplay: true,
              path: '/loading.json',
            });

            if (prefersReduced) {
              animation.addEventListener('DOMLoaded', () => {
                try {
                  animation.goToAndStop(0, true);
                } catch (error) {
                  void error;
                }
              });
            }
          })
          .catch((error) => {
            void error;
            hidePreloader();
          });
      }
    